import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const EntityRoutes = [
  {
    path: '/entities',
    name: 'ListEntities',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'entity:list'
    }
  },
  {
    path: '/entity',
    name: 'CreateEntity',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'entity:create'
    }
  },
  {
    path: '/entity/:id',
    name: 'UpdateEntity',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'entity:update'
    }
  },
  {
    path: '/entity/view/:id',
    name: 'GetEntity',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'entity:get'
    }
  }
]
